import React from 'react';
import { Navigation, Star, Clock, MapPin, Heart } from 'lucide-react';

const HyderabadLocalAttractions = () => {
  const localAttractions = [
    {
      id: 1,
      name: 'Charminar',
      category: 'Historical',
      rating: 4.7,
      distance: '2 km',
      time: '2-3 hours',
      image: 'https://tourism.telangana.gov.in/storage/app/media/charminar-landscape.jpg',
      featured: true,
      popular: true
    },
    {
      id: 2,
      name: 'Golconda Fort',
      category: 'Historical',
      rating: 4.6,
      distance: '11 km',
      time: '3-4 hours',
      image: 'https://thumbs.dreamstime.com/b/golconda-fort-3720711.jpg',
      featured: true,
      popular: true
    },
    {
      id: 3,
      name: 'Chowmahalla Palace',
      category: 'Historical',
      rating: 4.5,
      distance: '3 km',
      time: '2 hours',
      image: 'https://www.deccan-heritage-foundation.org/wp-content/uploads/2023/12/20211211_111822-1-scaled.jpg'
    },
    {
      id: 4,
      name: 'Salarjung Museum',
      category: 'Museum',
      rating: 4.4,
      distance: '4 km',
      time: '3 hours',
      image: 'https://i0.wp.com/weekendyaari.in/wp-content/uploads/2024/11/Salarjung-Museum-hyd.webp?fit=1500%2C1000&ssl=1'
    },
    {
      id: 5,
      name: 'Ramoji Film City',
      category: 'Entertainment',
      rating: 4.8,
      distance: '25 km',
      time: 'Full Day',
      image: 'https://assets.simplotel.com/simplotel/image/upload/x_0,y_124,w_2658,h_1496,r_0,c_crop/q_80,w_900,dpr_1,f_auto,fl_progressive,c_limit/ramoji-studio-tour/Ramoji_Film_City_Signage_vb9v0p',
      featured: true
    },
    {
      id: 6,
      name: 'Hussain Sagar Lake',
      category: 'Park & Lake',
      rating: 4.3,
      distance: '5 km',
      time: '2-3 hours',
      image: 'https://media.istockphoto.com/id/825421318/photo/statue-of-buddha.jpg?s=612x612&w=0&k=20&c=SAAfHWGdwK2OtMXFU0fpUGJ_arvDfIOFqTRRNFTn3A4='
    },
    {
      id: 7,
      name: 'Lumbini Park',
      category: 'Park',
      rating: 4.2,
      distance: '5 km',
      time: '2 hours',
      image: 'https://upload.wikimedia.org/wikipedia/commons/c/c2/Lumbini_Park%2C_Hyderabad.jpg'
    },
    {
      id: 8,
      name: 'Kutub Shahi Tombs',
      category: 'Historical',
      rating: 4.1,
      distance: '12 km',
      time: '2 hours',
      image: 'https://sceneloc8.com/wp-content/uploads/2024/03/Qutb-Shahi-Tombs.png'
    },
    {
      id: 9,
      name: 'Snow World',
      category: 'Entertainment',
      rating: 4.4,
      distance: '6 km',
      time: '3-4 hours',
      image: 'https://hblimg.mmtcdn.com/content/hubble/img/additionalttdimages/mmt/activities/m_Snow_World_Mumbai_1_l_423_640.jpg'
    },
    {
      id: 10,
      name: 'Birla Mandir',
      category: 'Religious',
      rating: 4.6,
      distance: '4 km',
      time: '1-2 hours',
      image: 'https://media.istockphoto.com/id/1287047140/photo/birla-mandir-hindu-temple-in-jaipur-rajasthan-india.jpg?s=612x612&w=0&k=20&c=zV5xu5vkxT_n0t4tFDAj1ygafeB0U7z00UjF0_2ETzM=',
      popular: true
    },
    {
      id: 11,
      name: 'Yadagiri Gutta',
      category: 'Religious',
      rating: 4.7,
      distance: '60 km',
      time: 'Full Day',
      image: 'https://s7ap1.scene7.com/is/image/incredibleindia/sri-lakshmi-narasimha-swamy-temple-or-yadadri-temple-or-yadagirigutta-temple-bhongir-telangana-1-attr-hero?qlt=82&ts=1751458838484'
    },
    {
      id: 12,
      name: 'Swarnagiri Temple',
      category: 'Religious',
      rating: 4.3,
      distance: '55 km',
      time: 'Full Day',
      image: 'https://thetempleguru.com/wp-content/uploads/2024/09/Sree-Venkateswara-Swamy-Devasthanam-Swarnagiri-20.jpg'
    }
  ];

  return (
    <div className="min-h-screen bg-gradient-to-b from-purple-50 via-white to-amber-50 py-8 px-4">
      {/* Header with Navigation */}
      <div className="max-w-6xl mx-auto">
        <div className="flex justify-between items-center mb-8">
          <div>
            <h1 className="text-3xl md:text-4xl font-bold text-gray-900">
              Hyderabad <span className="text-purple-600" style={{ color: 'rgba(65, 1, 150, 1)' }}>Local Attractions</span>
            </h1>
            <p className="text-gray-600 mt-2">Discover the gems of the City of Pearls</p>
          </div>
          <button className="bg-purple-600 hover:bg-purple-700 text-white font-semibold px-6 py-3 rounded-full shadow-lg transition-all duration-300 hover:scale-105 flex items-center gap-2" style={{ background: 'rgba(65, 1, 150, 1)' }}>
            <Navigation className="w-5 h-5" />
            Plan Route
          </button>
        </div>

        {/* Stats Cards */}
        {/* <div className="grid grid-cols-2 md:grid-cols-4 gap-4 mb-12">
          <div className="bg-white p-4 rounded-2xl shadow-sm border border-purple-100">
            <div className="text-2xl font-bold text-purple-700">12+</div>
            <div className="text-gray-600 text-sm">Attractions</div>
          </div>
          <div className="bg-white p-4 rounded-2xl shadow-sm border border-purple-100">
            <div className="text-2xl font-bold text-purple-700">4.5★</div>
            <div className="text-gray-600 text-sm">Avg Rating</div>
          </div>
          <div className="bg-white p-4 rounded-2xl shadow-sm border border-purple-100">
            <div className="text-2xl font-bold text-purple-700">400+</div>
            <div className="text-gray-600 text-sm">Years History</div>
          </div>
          <div className="bg-white p-4 rounded-2xl shadow-sm border border-purple-100">
            <div className="text-2xl font-bold text-purple-700">24/7</div>
            <div className="text-gray-600 text-sm">Open Attractions</div>
          </div>
        </div> */}

        {/* Desktop View - Network Map */}
        <div className="hidden lg:block relative max-w-[1400px] mx-auto h-[700px]">
          
          {/* HYDERABAD Center */}
          <div className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2">
            <div className="text-center">
              <div 
                className="relative bg-gradient-to-br from-purple-600 to-purple-800 overflow-hidden shadow-2xl mx-auto transition-all duration-500 hover:scale-110 hover:shadow-3xl group"
                style={{
                  width: '280px',
                  height: '280px',
                  clipPath: 'polygon(50% 0%, 100% 25%, 100% 75%, 50% 100%, 0% 75%, 0% 25%)',
                  borderRadius: '20%',
                 color: 'rgba(65, 1, 150, 1)' 
                }}
              >
                <img 
                  src="https://media.istockphoto.com/id/2168524178/photo/group-of-people-in-front-of-building.jpg?s=612x612&w=0&k=20&c=zhIMeFy0MdJHZ17bhv3LqvcdRsJ1w_uIQ3i1Nv5s82c="
                  alt="Hyderabad"
                  className="w-full h-full object-cover opacity-80 group-hover:opacity-100 transition-opacity"
                />
                {/* <div className="absolute inset-0 bg-gradient-to-t from-purple-900/70 to-transparent"></div> */}
                <div className="absolute bottom-6 left-0 right-0 text-center">
                  <h2 className="text-4xl font-bold text-white drop-shadow-lg">HYDERABAD</h2>
                  <p className="text-purple-200 mt-2">City of Pearls</p>
                </div>
              </div>
            </div>
          </div>

          {/* Connection Lines - Outer Ring */}
          <svg className="absolute inset-0 w-full h-full" style={{ zIndex: 0 }}>
            {localAttractions.slice(0, 8).map((_, index) => {
              const angle = (index / 8) * 2 * Math.PI;
              const x1 = 700 + 400 * Math.cos(angle);
              const y1 = 350 + 400 * Math.sin(angle);
              return (
                <line 
                  key={index}
                  x1="700" 
                  y1="350" 
                  x2={x1} 
                  y2={y1} 
                  stroke="#a855f7" 
                  strokeWidth="1.5" 
                  strokeDasharray="8,8" 
                  opacity="0.4"
                />
              );
            })}
            
            {/* Inner Ring Connections */}
            {localAttractions.slice(8, 12).map((_, index) => {
              const angle = (index / 4) * 2 * Math.PI;
              const x1 = 700 + 200 * Math.cos(angle);
              const y1 = 350 + 200 * Math.sin(angle);
              return (
                <line 
                  key={index + 8}
                  x1="700" 
                  y1="350" 
                  x2={x1} 
                  y2={y1} 
                  stroke="#f59e0b" 
                  strokeWidth="1.5" 
                  strokeDasharray="6,6" 
                  opacity="0.3"
                />
              );
            })}
          </svg>

          {/* Attractions - Outer Ring */}
          <div className="absolute inset-0" style={{ zIndex: 1 }}>
            {localAttractions.slice(0, 8).map((attraction, index) => {
              const angle = (index / 8) * 2 * Math.PI;
              const left = 700 + 400 * Math.cos(angle) - 75;
              const top = 350 + 400 * Math.sin(angle) - 75;
              
              return (
                <div 
                  key={attraction.id}
                  className="absolute transition-all duration-500 hover:scale-125 hover:z-20"
                  style={{ left: `${left}px`, top: `${top}px` }}
                >
                  <div className="text-center">
                    <div className="w-36 h-36 rounded-full overflow-hidden shadow-2xl border-4 border-white bg-white group cursor-pointer">
                      <img 
                        src={attraction.image} 
                        alt={attraction.name} 
                        className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                      />
                      {attraction.popular && (
                        <div className="absolute top-2 right-2 bg-red-500 text-white text-xs px-2 py-1 rounded-full">
                          Popular
                        </div>
                      )}
                    </div>
                    <div className="mt-4">
                      <p className="text-gray-900 font-bold text-lg">{attraction.name}</p>
                      <div className="flex items-center justify-center gap-4 mt-2 text-sm text-gray-600">
                        <span className="flex items-center gap-1">
                          <Star className="w-4 h-4 text-yellow-500 fill-yellow-500" />
                          {attraction.rating}
                        </span>
                        <span className="flex items-center gap-1">
                          <MapPin className="w-4 h-4" />
                          {attraction.distance}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
              );
            })}

            {/* Inner Ring Attractions */}
            {localAttractions.slice(8, 12).map((attraction, index) => {
              const angle = (index / 4) * 2 * Math.PI;
              const left = 700 + 200 * Math.cos(angle) - 60;
              const top = 350 + 200 * Math.sin(angle) - 60;
              
              return (
                <div 
                  key={attraction.id}
                  className="absolute transition-all duration-500 hover:scale-125 hover:z-10"
                  style={{ left: `${left}px`, top: `${top}px` }}
                >
                  <div className="text-center">
                    <div className="w-28 h-28 rounded-full overflow-hidden shadow-xl border-4 border-white bg-white group cursor-pointer">
                      <img 
                        src={attraction.image} 
                        alt={attraction.name} 
                        className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                      />
                    </div>
                    <div className="mt-3">
                      <p className="text-gray-800 font-semibold">{attraction.name}</p>
                    </div>
                  </div>
                </div>
              );
            })}
          </div>

          {/* Floating Categories */}
          <div className="absolute left-10 top-10 bg-white/90 backdrop-blur-sm p-4 rounded-2xl shadow-lg">
            <h3 className="font-bold text-gray-800 mb-2">Categories</h3>
            <div className="space-y-1">
              <div className="flex items-center gap-2">
                <div className="w-3 h-3 rounded-full bg-purple-600"></div>
                <span className="text-sm">Historical Sites</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-3 h-3 rounded-full bg-blue-600"></div>
                <span className="text-sm">Religious Places</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-3 h-3 rounded-full bg-green-600"></div>
                <span className="text-sm">Parks & Lakes</span>
              </div>
              <div className="flex items-center gap-2">
                <div className="w-3 h-3 rounded-full bg-amber-600"></div>
                <span className="text-sm">Entertainment</span>
              </div>
            </div>
          </div>

        </div>

        {/* Mobile/Tablet View */}
        <div className="lg:hidden">
          
          {/* Featured Attractions */}
          <div className="mb-10">
            <h3 className="text-2xl font-bold text-gray-900 mb-6">⭐ Featured Attractions</h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {localAttractions.filter(a => a.featured).map(attraction => (
                <div key={attraction.id} className="bg-white rounded-2xl overflow-hidden shadow-lg border border-gray-100">
                  <div className="relative h-48">
                    <img 
                      src={attraction.image} 
                      alt={attraction.name} 
                      className="w-full h-full object-cover"
                    />
                    <div className="absolute top-4 right-4">
                      <button className="p-2 bg-white/90 backdrop-blur-sm rounded-full">
                        <Heart className="w-5 h-5 text-gray-600" />
                      </button>
                    </div>
                    {attraction.popular && (
                      <div className="absolute top-4 left-4 bg-red-500 text-white text-sm px-3 py-1 rounded-full">
                        Popular
                      </div>
                    )}
                  </div>
                  <div className="p-4">
                    <div className="flex items-start justify-between">
                      <div>
                        <h4 className="font-bold text-lg text-gray-900">{attraction.name}</h4>
                        <p className="text-gray-600 text-sm mt-1">{attraction.category}</p>
                      </div>
                      <div className="flex items-center gap-1 bg-purple-50 px-3 py-1 rounded-full">
                        <Star className="w-4 h-4 text-yellow-500 fill-yellow-500" />
                        <span className="font-bold">{attraction.rating}</span>
                      </div>
                    </div>
                    <div className="flex items-center justify-between mt-4">
                      <div className="flex items-center gap-4 text-sm text-gray-600">
                        <span className="flex items-center gap-1">
                          <MapPin className="w-4 h-4" />
                          {attraction.distance}
                        </span>
                        <span className="flex items-center gap-1">
                          <Clock className="w-4 h-4" />
                          {attraction.time}
                        </span>
                      </div>
                      <button className="px-4 py-2 bg-purple-600 text-white text-sm font-semibold rounded-lg hover:bg-purple-700 transition-all" style={{ background: 'rgba(65, 1, 150, 1)' }}>
                        Visit
                      </button>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* All Attractions Grid */}
          <div>
            <h3 className="text-2xl font-bold text-gray-900 mb-6">📍 All Attractions</h3>
            <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
              {localAttractions.map(attraction => (
                <div key={attraction.id} className="bg-white rounded-xl overflow-hidden shadow-sm border border-gray-100 group cursor-pointer">
                  <div className="relative h-32">
                    <img 
                      src={attraction.image} 
                      alt={attraction.name} 
                      className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-300"
                    />
                    <div className="absolute top-2 right-2">
                      <div className="flex items-center gap-1 bg-black/60 text-white text-xs px-2 py-1 rounded-full">
                        <Star className="w-3 h-3" />
                        {attraction.rating}
                      </div>
                    </div>
                  </div>
                  <div className="p-3">
                    <h5 className="font-semibold text-gray-900 truncate">{attraction.name}</h5>
                    <p className="text-xs text-gray-600 mt-1 truncate">{attraction.category}</p>
                    <div className="flex items-center justify-between mt-2">
                      <span className="text-xs text-gray-500 flex items-center gap-1">
                        <MapPin className="w-3 h-3" />
                        {attraction.distance}
                      </span>
                      <span className="text-xs text-gray-500">{attraction.time}</span>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Quick Stats */}
          
        </div>

        {/* Bottom Navigation for Mobile */}
       
      </div>
    </div>
  );
};

export default HyderabadLocalAttractions;